import type { SelectItemDefault } from '@consta/uikit/Select'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

import { EMPTY_PALETTE_ID } from '../../../../../constants'
import type { PaletteId } from '../../../../../types'
import { SettingSelect } from './SettingSelect'

type PaletteItem = {
  id: string
  label: string
}

type SettingPaletteProps = {
  className?: string
  label: string
  errorText?: string
  paletteId: Nullable<PaletteId>
  palettes: PaletteItem[]
  placeholder?: string
  onChange: (value: Nullable<PaletteId>) => void
}

export const SettingPalette: FC<SettingPaletteProps> = ({
  onChange,
  label,
  paletteId,
  palettes,
  errorText,
  className,
  placeholder,
}) => {
  const [selectedPalette, setSelectedPalette] = useState<Nullable<PaletteItem>>(null)

  useEffect(() => {
    setSelectedPalette(
      palettes.find(palette => palette.id === (paletteId ?? EMPTY_PALETTE_ID)) ?? null,
    )
  }, [paletteId, palettes])

  const changePalette = (selectedPalette: Nullable<SelectItemDefault>) => {
    const foundPalette = palettes.find(palette => palette.id === selectedPalette?.id) ?? null
    const paletteId = foundPalette?.id === EMPTY_PALETTE_ID ? null : (foundPalette?.id ?? null)
    setSelectedPalette(foundPalette)
    onChange(paletteId)
  }

  return (
    <SettingSelect
      className={className}
      label={label}
      errorText={errorText}
      value={selectedPalette}
      items={palettes}
      placeholder={placeholder}
      onChange={changePalette}
    />
  )
}
